<template>
  <div id="app">

    <!-- Login -->
    <div v-if="!logueado">
      <home/>
    </div>

    <!-- Inicio -->
    <div v-else class="mt-2 mx-5">

      <AppHeader/>

      <AppMenu/>

      <div class="my-1">
        <b-card bg-variant="light" border-variant="primary">
          <router-view/>
        </b-card>
      </div>

      <!-- <div>{{ $store.state.G.url }}</div> -->

      <AppFooter/>

    </div>

    <!-- <b-button v-b-modal.modal_login>Login</b-button> -->
    <!-- <b-button @click="modal('modal_login')">Login</b-button> -->
    <!-- <b-button @click="modal('modal_registro')">Registro</b-button> -->

    <!-- Componentes -->
    <loading ref="loading"></loading>
    <alerta ref="alerta"></alerta>
    <modal ref="modal"></modal>

    <!-- ModalC -->
    <modalC></modalC>

    <!---------------------------- modales  -------------------------->
    <!-- login -->
    <!-- <loginM/>     -->
    <!-- registro -->
    <!-- <registroM/> -->
    <!-- confirmacion Codigo -->
    <!-- <confCodigo/> -->

    <!-- hotel precios -->
    <hotelPreciosM/>
    <hotelDispoM/>
    <reservaInfoM/>

    <!-- Buscar Expediente -->
    <buscaExpedM/>

    <!-- https://www.npmjs.com/package/vue-cookie-law -->
    <!-- COOKIE Consentimiento -->
    <!-- <cookie-law theme="blood-orange" position="bottom"
      buttonText="Aceptar" buttonLinkText="Información">
      <div slot="message">
        Usamos cookies para que tenga la mejor experiencia de usuario. Si continúa navegando está dando su consentimiento para la aceptación de las mencionadas cookies y la aceptación de nuestra política de cookies.
        <router-link to="/cookies">Mas Información</router-link>
      </div>
    </cookie-law>     -->

  </div>
</template>

<script>

import loading from '@/components/loading.vue'
import alerta from '@/components/alerta.vue'
import modal from '@/components/modal.vue'
import modalC from '@/components/ModalC.vue'

import AppHeader from '@/components/AppHeader.vue'
import AppMenu from '@/components/AppMenu.vue'
import home from '@/components/home.vue'
import AppFooter from '@/components/AppFooter.vue'

// login, registro
// import loginM from '@/components/LoginM.vue'
// import registroM from '@/components/RegistroM.vue'
// import confCodigo from '@/components/confCodigo.vue'
// modales
import hotelPreciosM from '@/components/hotel-preciosM.vue'
import hotelDispoM from '@/components/hotel-dispoM.vue'
import buscaExpedM from '@/components/busca-expedM.vue'
import reservaInfoM from '@/components/reservaInfoM.vue'

//aceptar cookies
// import CookieLaw from 'vue-cookie-law'

export default {
  name: 'App',
  components: {
    loading, alerta,
    modal,
    AppHeader,AppMenu,AppFooter,
    home,
    modalC,
    //modales
    //loginM, registroM,
    //confCodigo,
    hotelPreciosM,
    hotelDispoM,
    buscaExpedM,
    reservaInfoM,
    //CookieLaw,

  },
  data() {
    return {
      title: 'CASTELLON SENIOR - VIAJES CEMO',
      // datos: false,
    }
  },

  computed: {
        logueado() {
            return this.$store.state.auth.logueado;
        },
  },

  methods: {
    modal(component) {
      this.$bvModal.show(component);
    },

    async hotelPrecios(hotel) {
      await this.$store.dispatch('hotel_precios', hotel);
      this.$bvModal.show("modal_hotelPrecios");
    },

    async hotelDispo() {
      //await this.$store.dispatch('hoteles');
      this.$bvModal.show("modal_hotelDispo");
    },

    async reservaInfo() {
      //await this.$store.dispatch('hoteles');
      this.$bvModal.show("modal_reservaInfo");
    },

    //////////////////////////////////////////////////////////////////////////////////
    //modales Informacion y Confirmacion
    async msgConf(txt,tit="Atención") {
        let msg=this.htmlToVNode(txt);
        const value = await this.$bvModal.msgBoxConfirm(msg, {
            headerClass: "p-1 bg-primary text-light text-weight-bold",
            title: tit,
            size: "md", buttonSize: "sm",
            okVariant: "outline-primary", okTitle: "ACEPTAR",
            cancelVariant: "dark text-light", cancelTitle: "CANCELAR",
            footerClass: "p-2 text-light",
            hideHeaderClose: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            centered: true
        });
        return value;
    },
    async msgBox(txt,tit="INFORMACIÓN") {
        let msg=this.htmlToVNode(txt);
        const value = await this.$bvModal.msgBoxOk(msg, {
            title: tit,
            size: "md", buttonSize: "sm",
            okVariant: "outline-primary", okTitle: "ole",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
        });
        return value;
    },
    htmlToVNode(html) {
        return [ this.$createElement('div', { domProps: { innerHTML: html } }) ];
    },

    /* toast(txt,tit="INFORMACIÓN") {
      let msg=this.htmlToVNode(txt);

      this.$bvToast.toast([msg], {
          title: [tit],
          solid: true,
          static: true,
          variant: 'danger'
      })
    }, */



  },
  async created() {
    document.title=this.title;
    //sessionStorage.clear;
    //console.log("* app.created",sessionStorage);

    //await this.$store.dispatch("isLogin");

    // establezo las urls / pruebas
    this.$store.commit('G/set_URLS');


  },
  async mounted() {
    //almacenamo en comps - store
    this.$store.state.comps.loading=this.$refs.loading;
    this.$store.state.comps.alerta=this.$refs.alerta;
    this.$store.state.comps.modal=this.$refs.modal;
    //$root
    this.$root.$msgBox=this.msgBox;
    this.$root.$msgConf=this.msgConf;
    //this.$root.$toast=this.toast;
    //modales
    this.$root.$hotelPrecios=this.hotelPrecios;
    this.$root.$hotelDispo=this.hotelDispo;

    // compruebo si estamos logueados
    await this.$store.dispatch("isLogin");
    //cargamos datos iniciales
    //await this.$store.dispatch("datos_iniciales");

    //console.log("* app.mounted",this.$store.state.auth);
  },

}
</script>

<style>

  @import './assets/css/main.css';

</style>
